import {
    defineNuxtPlugin,
} from '#app'
import {
    ClosePopup,
    QBadge,
    QBanner,
    QBtn,
    QCard,
    QCardSection,
    QCheckbox,
    QDate,
    QDrawer,
    QExpansionItem,
    QForm,
    QHeader,
    QIcon,
    QInput,
    QItem,
    QItemLabel,
    QItemSection,
    QLayout,
    QList,
    QPage,
    QPageContainer,
    QPopupProxy,
    QSelect,
    QSpinner,
    QTable,
    QToolbar,
    QToolbarTitle,
    Quasar,
} from 'quasar'

export default defineNuxtPlugin(nuxtApp => {
    
    const quasarUserOptions = {
        components: {
            QPage,
            QBtn,
            QToolbarTitle,
            QToolbar,
            QCard,
            QCardSection,
            QPageContainer,
            QList,
            QLayout,
            QDrawer,
            QHeader,
            QItemLabel,
            QIcon,
            QItemSection,
            QItem,
            QExpansionItem,
            QSpinner,
            QTable,
            QForm,
            QInput,
            QSelect,
            QCheckbox,
            QBanner,
            QPopupProxy,
            QDate,
            QBadge,
        },
        directives: {
            ClosePopup,
        },
        plugins: {},
    }
    
    nuxtApp.vueApp.use(Quasar, quasarUserOptions)
    
})
